/**
 * Gets the hostname (without TLD) from the current hostname, uppercased.
 * If the hostname is localhost or has no TLD, defaults to 'SECURESURF'
 *
 * @returns {string} The hostname to use (e.g., 'SECURESURF' or 'VPN123')
 */
export function getHostname() {
  const hostname = window.location.hostname;

  // Handle localhost or IP addresses
  if (hostname === 'localhost' || hostname === '127.0.0.1' || !hostname.includes('.')) {
    return 'SECURESURF';
  }

  // Extract hostname without TLD
  // For 'securesurfnet.com' -> 'SECURESURFNET'
  // For 'vpn123.net' -> 'VPN123'
  // For 'app.securesurfnet.com' -> 'SECURESURFNET' (takes the first part before the domain)
  const parts = hostname.split('.');

  // If we have at least 2 parts, take the part before the TLD
  // For subdomains like 'app.vpn111.com', we want 'vpn111', so we take parts[parts.length - 2]
  if (parts.length >= 2) {
    // Get the part before the TLD (second to last part)
    const hostnamePart = parts[parts.length - 2];
    return hostnamePart.toUpperCase();
  }

  // Fallback to default
  return 'SECURESURF';
}

/**
 * Display name for checkout branding only.
 * Maps "securesurfnet" / localhost "securesurf" to "SURFNET".
 * Other hostnames are unchanged.
 *
 * @returns {string}
 */
export function getCheckoutHostname() {
  const name = getHostname();
  if (name === 'SECURESURFNET' || name === 'SECURESURF') {
    return 'SURFNET';
  }
  return name;
}
